import {
  Col,
  Container,
  Dropdown,
  FloatingLabel,
  Form,
  InputGroup,
  Placeholder,
  Row,
  Table,
} from "react-bootstrap";
import { HeadPage } from "src/componentes";
import ProdutoCode from "./Produto.Code";
import { useNavigate } from "react-router-dom";

const ProdutoView = () => {
  const navigate = useNavigate();
  const { register, errors, handleSubmit, onSubmit, loading, data, menuItens } =
    ProdutoCode();

  const handleClickNavigate = (route: string) => () => {
    navigate(route);
  };

  const handleClickAlterar = (id: number) => () => {
    navigate(`/estoque/produtos/cadastro?id=${id}`);
  };

  return (
    <Container>
      <HeadPage headText="Produtos">
        {menuItens !== undefined &&
          menuItens.map((item) => (
            <Dropdown.Item
              key={item.nome}
              onClick={handleClickNavigate(item.rota)}
            >
              {item.nome}
            </Dropdown.Item>
          ))}
        <Dropdown.Item onClick={() => navigate("/estoque/produtos/importar")}>
          Importar CSV
        </Dropdown.Item>
      </HeadPage>
      <Row>
        <Col>
          <Form noValidate onSubmit={handleSubmit(onSubmit)}>
            <InputGroup hasValidation>
              <FloatingLabel controlId="pesquisar" label="Pesquisar">
                <Form.Control
                  type="text"
                  placeholder="Pesquisar"
                  isInvalid={!!errors.nome?.message?.toString()}
                  {...register("nome")}
                />
                {errors.nome?.message?.toString() && (
                  <Form.Control.Feedback type="invalid">
                    {errors.nome?.message?.toString()}
                  </Form.Control.Feedback>
                )}
              </FloatingLabel>
            </InputGroup>
          </Form>
        </Col>
      </Row>
      <Row>
        {!loading ? (
          <>
            <Col>
              {data && data.length > 0 ? (
                <Table responsive hover>
                  <thead>
                    <tr>
                      <th className="col-xs-10 col-md-8">Nome</th>
                      <th className="d-none d-sm-table-cell col-02">Und</th>
                      <th className="col-2 text-end">Valor</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.map((item) => (
                      <tr
                        key={item.id}
                        onClick={handleClickAlterar(item.id)}
                        style={{ cursor: "pointer" }}
                      >
                        <td className="col-xs-12 col-md-8">
                          {item.nome} {"[" + item.codigoProduto + "]"}
                        </td>
                        <td className="d-none d-sm-table-cell col-02">
                          {item.unidadeComercial}
                        </td>
                        <td className="col-2 text-end">
                          {item.valorUnitarioComercial
                            .toFixed(2)
                            .replace(".", ",")}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              ) : (
                <Form.Text>Sem Dados</Form.Text>
              )}
            </Col>
          </>
        ) : (
          <Placeholder as={FloatingLabel} animation="glow">
            <Placeholder xs={12} />
          </Placeholder>
        )}
      </Row>
    </Container>
  );
};
export default ProdutoView;
